import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-blue selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Hook data-id="element-2" />
      <Problem data-id="element-3" />
      <FailedAttempts data-id="element-4" />
      <Mechanism data-id="element-5" />
      <Deliverables data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <Offer data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}